import { render, staticRenderFns } from "./FaqOtherCategories.vue?vue&type=template&id=3a661227&"
import script from "./FaqOtherCategories.vue?vue&type=script&lang=js&"
export * from "./FaqOtherCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports